import Axios from "axios";
import Router from "next/router";
import React, { useEffect } from "react";
import sanitizeHtml from "sanitize-html";
import styled from "styled-components";
import FooterComponent from "@/components/Footer/FooterComponent";
import Header from "@/components/Header/Header";
import SEOHead from "@/components/SEOHead/SEOHead";
import { WordPressAPI } from "../config";

const BasicContent = styled.section`
  p {
    font-weight: 400;
    &.title {
      text-align: center;
      text-transform: capitalize;
      font-size: 2rem;
      margin-bottom: 1em;
      strong {
        font-weight: 300;
      }
    }
  }
`;

const TermsOfUse = ({ data: { acf, content } }) => {
  const { meta_description, paid_campaign, additional_questions } = acf;

  useEffect(() => {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener("click", function (e) {
        e.preventDefault();

        const href = this.getAttribute("href");

        Router.push(href, href, { shallow: true });

        const element = document.getElementById(href.replace("#", ""));

        const yOffset = -50;
        const y =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: "smooth" });
      });
    });
  }, []);

  return (
    <div>
      <SEOHead>
        <title>Terms of Service</title>
        <meta name="description" content={meta_description} key="description" />
      </SEOHead>
      <Header
        AdditionalQuestions={additional_questions}
        PaidCampaign={paid_campaign}
      />
      <BasicContent>
        <div
          className="container"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(content.rendered, {
              allowedTags: ["h2", "p", "ul", "ol", "li", "strong", "a"],
              allowedAttributes: {
                a: ["href", "target"],
                p: ["id"],
              },
            }),
          }}
        />
      </BasicContent>
      <FooterComponent />
    </div>
  );
};

export const getStaticProps = async () => {
  const { data } = await Axios.get(`${WordPressAPI.pages}/171`);
  return {
    props: {
      data,
    },
    // revalidate: 60,
  };
};

export default TermsOfUse;
